// Makes the current tool's slug available to anything rendered inside a tool
// page — chiefly SaveToCanvasBar, which needs to tag its hand-off with the tool
// the visitor actually used.
//
// Reading the slug from context rather than from each widget's `source` prop
// keeps the attribution campaign identical to the tool's real slug (and to its
// /tools/<slug> URL), instead of the 30-odd hand-written names that had drifted
// from it ("cornell_save" vs "cornell-notes").

import { createContext, useContext } from "react";

const ToolSlugContext = createContext<string | null>(null);

export const ToolSlugProvider = ToolSlugContext.Provider;

/**
 * The enclosing tool's slug, or null when a widget is rendered outside a tool
 * page (the demo canvas, for instance) — callers fall back to their own label.
 */
export function useToolSlug(): string | null {
  return useContext(ToolSlugContext);
}
